import { emptyArchetype, type ComposePlan } from "./types";

/** Normalize a plan blob from remote JSON or import into a ComposePlan. */
export function hydrateComposePlan(
  raw: unknown,
  opts: { orgId: string; planId?: string },
): ComposePlan | null {
  if (!raw || typeof raw !== "object") return null;
  const p = raw as Record<string, unknown>;
  if (p.version !== 1 && p.version !== undefined) return null;
  const planId =
    (typeof opts.planId === "string" && opts.planId) ||
    (typeof p.planId === "string" && p.planId) ||
    "";
  if (!planId) return null;

  const archetypeRaw =
    p.archetype && typeof p.archetype === "object" && !Array.isArray(p.archetype)
      ? (p.archetype as Parameters<typeof emptyArchetype>[0])
      : undefined;

  return {
    version: 1,
    planId,
    orgId: opts.orgId,
    entryMode: p.entryMode === "top_down" ? "top_down" : "bottom_up",
    step:
      p.step === "entry" ||
      p.step === "define" ||
      p.step === "review" ||
      p.step === "match" ||
      p.step === "commit"
        ? p.step
        : "define",
    archetype: emptyArchetype(archetypeRaw),
    nodes: Array.isArray(p.nodes) ? (p.nodes as ComposePlan["nodes"]) : [],
    matchBoosts: Array.isArray(p.matchBoosts)
      ? p.matchBoosts.filter((x): x is string => typeof x === "string")
      : [],
    confirmedLinks: Array.isArray(p.confirmedLinks)
      ? (p.confirmedLinks as ComposePlan["confirmedLinks"])
      : [],
    createdAt:
      typeof p.createdAt === "string" && p.createdAt
        ? p.createdAt
        : new Date().toISOString(),
    updatedAt:
      typeof p.updatedAt === "string" && p.updatedAt
        ? p.updatedAt
        : new Date().toISOString(),
  };
}
